import { CalendarContainer } from '@calendar/components/calendar-container';
import { CalendarFiltersProvider } from '@calendar/context/CalendarFiltersContext';
import { useScrollToTop } from '@calendar/hooks/use-scroll-to-top';
import { useCalendarFiltersContext } from '@calendar/context/CalendarFiltersContext';
import { useEvents } from '@calendar/hooks/use-events';
import { useCategories } from '@calendar/hooks/use-categories';
import { VIEWS } from '@calendar/lib/constants';

function CalendarAppContent() {
  const { events, isLoading, error } = useEvents();
  const { categories, isLoading: categoriesLoading, error: categoriesError } = useCategories();
  const { filters } = useCalendarFiltersContext();

  // Hook to scroll to top of entire calendar app when filters change
  const calendarAppRef = useScrollToTop(filters, {
    behavior: 'smooth',
    block: 'start',
    delay: 100, // Small delay to allow content to render
    offset: 58  // 58px buffer above the calendar app
  });

  return (
    <div ref={calendarAppRef} className="app--calendar">
      <CalendarContainer
        events={events}
        isLoading={isLoading}
        error={error}
        categories={categories}
        categoriesLoading={categoriesLoading}
        categoriesError={categoriesError}
        views={VIEWS}
      />
    </div>
  );
}

export default function CalendarApp() {
  return (
    <CalendarFiltersProvider>
      <CalendarAppContent />
    </CalendarFiltersProvider>
  );
}
